import React from 'react';
import { connect } from 'react-redux';

import { SubActions, isInvite } from 'Redux/thunks/subscriptions.thunks';
import { findSubscription } from '../utils/subscription.utils';

import { AcceptInvitation } from '../components/connect-subscription/AcceptInvitation.view';

import type { Subscription } from 'src/types/subscription.types';
import type { AppDispatch, RootState } from 'src/types/state.types';

const withUserInvited = (doneComponent: React.ComponentType<any>) => {
  const MemberGuard: React.FC<{
    invited: boolean;
    subId: string;
    onAccept?: (subId: string) => void;
    onDecline?: (subId: string) => void;
  }> = ({ subId, invited, onAccept, onDecline, ...restProps }) => {
    if (invited) {
      return <AcceptInvitation subId={subId} onAccept={onAccept} onDecline={onDecline} />;
    }
    const enhancedComponentProps = { subId, onAccept, onDecline, ...restProps };
    const EnhancedComponent = doneComponent;

    return <EnhancedComponent {...enhancedComponentProps} />;
  };

  function mapDispatchToProps(dispatch: AppDispatch) {
    return {
      onAccept: (subId: string) => dispatch((SubActions as any).accept(subId)),
      onDecline: (subId: string) => dispatch((SubActions as any).decline(subId)),
    };
  }

  function mapStateToProps(state: RootState) {
    const sub = findSubscription(state.subscriptions)(state.subscription.id) as Subscription;

    return {
      invited: isInvite(sub),
      subId: state.subscription.id,
    };
  }

  return connect(mapStateToProps, mapDispatchToProps)(MemberGuard);
};

export { withUserInvited };
